<template>
    <el-drawer
        title="修改登录密码"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
               
				<el-form-item prop="pwd" label="请输入新的登录密码:">					
					<span slot="label">新登录密码: <small>8-40个字符，且必须包含至少1位字母、1位数字、1位特殊字符（! @ # $ % ^ & *）</small></span>
					<el-input v-model="formData.pwd" placeholder="请输入新的登录密码" type="password" size="medium" maxlength="40" show-password  auto-complete="new-password"></el-input>
				</el-form-item>
               <el-form-item prop="pwd2" label="再次确认密码:">
               	<span slot="label">再次确认密码: <small>请保持两次密码一致</small></span>
               	<el-input v-model="formData.pwd2" placeholder="请再次确认密码" type="password" size="medium" maxlength="40" show-password  auto-complete="new-password"></el-input>
               </el-form-item>
                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="loading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
   pwd:'',
   pwd2:''
}
export default {
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
		const validatePassword = (rule, value, callback) => {
		     //const _reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,40}$/;
			 const _reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,40}$/ // 至少1位字母、1位数字、1位特殊字符(!@#$%^&*)
		     if (!_reg.test(value)) {
		         callback(new Error("密码必须8-40个字符，且必须包含至少1位字母、1位数字、1位特殊字符（! @ # $ % ^ & *）"));
		     } else {
		         callback();
		     }
		 }
		 //验证确认密码
		 const validateNewPwd2 = (rule, value, callback) => {
		     if (value !== this.formData.pwd) {
		         callback(new Error("两次输入密码不一致!"));
		     } else {
		         callback();
		     }
		 }
        return {
            drawerShow: false,
            loading: false,
            formData: {
                ...defaultFormData
            },
            rules: {                
				pwd:[
				    {required:true,message:'请填写登录密码'},
					{validator:validatePassword}
				],
				pwd2:[
				    {required:true,message:'请再次确认新密码'},
					{validator:validateNewPwd2}
				],	
               
            },
			
           
        };
    },
    
    watch: {
       
    },
    methods: {

        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {                    
                    this.loading = true;
                    this.$request({
                        url: '/adminUser/edit/pwd',
                        data: {
							pwd:this.formData.pwd
						},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                self.$message.success("修改成功");
								this.close()
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>